import { IInvoiceInfo } from './../../models/annex';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, forkJoin, switchMap } from 'rxjs';

import { SnackbarService } from '../../services/snackbar.service';
import { ApiLotDetailService } from '../../services/api/api-lot-detail.service';
import {
  DetailLotEnum,
  IContractLot,
  ILot,
  LotStatus
} from 'src/app/models/generic';
import { ApiLotsService } from '../../services/api/api-lots.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CampoNfComponent } from './campo-nf/campo-nf.component';
import { CampoRpaComponent } from './campo-rpa/campo-rpa.component';
import { IAnnex } from '../../models/annex';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';

@Component({
  selector: 'app-detalhes-lotes',
  templateUrl: './detalhes-lotes.component.html',
  styleUrls: ['./detalhes-lotes.component.scss']
})
export class DetalhesLotesComponent implements OnInit, OnDestroy {
  DetailLotEnum = DetailLotEnum;
  typeDetailLot: DetailLotEnum = DetailLotEnum.Transfer;
  LotStatus = LotStatus;

  title = 'Detalhes do Lote';

  annexList: IAnnex[] = [
    {
      Title: 'Nota Fiscal',
      File: '',
      isLoader: false,
      visible: false,
      AllowDownload: false,
      DisableUpload: false
    },
    {
      Title: 'Memória de Cálculo',
      File: '',
      isLoader: false,
      visible: false,
      AllowDownload: false,
      DisableUpload: false
    },
    {
      Title: 'Gerar RPA',
      File: '',
      isLoader: false,
      visible: false,
      AllowDownload: false,
      DisableUpload: false
    }
  ];

  file: Blob | string | null = null;
  fileMemCalc: Blob | string | null = null;
  batchType: 'invoice' | 'transfer' = 'transfer';
  integratedOnSAP: boolean = false;
  allowIntegrationSap: boolean = false;
  allowLiberacaoManual: boolean = false;
  allowReintegrationSap: boolean = false;
  allowRefreshNFENumber: boolean = false;
  allowCancelSap: boolean = false;
  allowCancelAllContractsBatch: boolean = false;
  allowAttachment: boolean = false;
  id!: string;
  lote!: ILot;
  isLoading: boolean = true;

  contratosList?: IContractLot[];

  subscription!: Subscription;

  urlLote!: string;

  get appearance(): 'legacy' | 'modern' {
    return this.getRouteParent() === 'faturamento-contratos' ? 'modern' : 'legacy';
  }

  constructor(
    private _route: ActivatedRoute,
    private _lotDetailService: ApiLotDetailService,
    private router: Router,
    private snackbarService: SnackbarService,
    private _apiBatchService: ApiLotsService,
    private _dialog: MatDialog,
    private _dialogService: ApiDialogService
  ) {}

  ngOnInit(): void {
    this.id = this._route.snapshot.params['id'];
    this.defineGetOfBatch(this.id);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  defineGetOfBatch(id: string) {
    if (this.getRouteParent() === 'faturamento-contratos') {
      this.typeDetailLot = DetailLotEnum.Invoicing;
      this.batchType = 'invoice';
      this.getLotById(id);
    } else {
      this.allowAttachment = true;
      this.getLotTransfersById(id);
    }
  }

  getLotById(id: string) {
    this.subscription = this._apiBatchService
      .getLotsInvoicesById(id, true)
      .subscribe({
        next: (res) => {
          this.lote = res.Data;
          this.contratosList = this.lote?.Contracts;
          this.checkIntegrationSap();
          this.checkIfBatchIsCancelable();
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  getLotTransfersById(id: string) {
    this.subscription = this._apiBatchService
      .getLotTransfersById(id, true)
      .subscribe({
        next: (res) => {
          this.lote = res.Data;
          this.contratosList = this.lote?.Contracts;
          this.checkIntegrationSap();
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  checkIntegrationSap(): void {

    if (
      this.lote.BatchStatus?.toLowerCase().trim() === 'em andamento' ||
      (this.lote.BatchStatus?.toLowerCase().trim() === 'pre-faturado' &&
        this.lote.SapIntegrationError) ||
      this.lote.StatusOfOnlending?.toLowerCase().trim() === 'aprovado' ||
      (this.lote.IsInvoiced &&
        this.lote.StatusOfOnlending?.toLowerCase().trim() !== 'liberado') ||
      this.lote.IntegrationError
    )
      this.allowIntegrationSap = true;
      this.allowLiberacaoManual = this.typeDetailLot === DetailLotEnum.Transfer;

    if (this.lote.SapIntegrationError == true) {
      this.allowReintegrationSap = true;
      this.allowIntegrationSap = false;
      this.allowLiberacaoManual = false;
    }

    if (this.lote.BatchStatus?.toLowerCase().trim() === 'faturado') {
      this.integratedOnSAP = true;
      this.allowRefreshNFENumber = true;
    }

    if (
      this.lote.StatusOfOnlending?.toLowerCase().trim() === 'liberado' ||
      (this.lote.BatchStatus?.toLowerCase().trim() === 'cancelado' &&
        this.lote?.InvoiceNumber &&
        !this.lote?.CancelInvoiceNumber)
    )
      this.allowCancelSap = true;
  }

  integrateSap(): void {
    switch (this.typeDetailLot) {
      case DetailLotEnum.Invoicing:
        this.integrateSapInvoicing();
        break;

      case DetailLotEnum.Transfer:
        this.integrateSapTransfer();
        break;
    }
  }

  reSendIntegrateSap(): void {
    this.reSendSapInvoicing();
  }

  refreshNFENumber(): void {
    this._lotDetailService
      .refreshNFENumber(this.lote.BatchId.toString())
      .pipe(
        switchMap((response) =>
          this._lotDetailService.validationLotWithSap(
            this.lote.BatchId.toString()
          )
        )
      )
      .subscribe({
        next: (response) => {
          this.snackbarService.openSnackBar(
            'Atualização de lote realizada com sucesso!',
            'success',
            3000
          );

          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() =>
              this.router.navigate([
                `/faturamento-contratos/detalhes-lote/${this.lote.BatchId.toString()}`
              ])
            );
        }
      });
  }

  reSendSapInvoicing(): void {
    this._lotDetailService
      .clearBillIntegrationReSendSap(this.lote.BatchId.toString())
      .pipe(
        switchMap((response) =>
          this._lotDetailService.validationLotWithSap(
            this.lote.BatchId.toString()
          )
        )
      )
      .subscribe({
        next: (response) => {
          this.snackbarService.openSnackBar(
            'Reintegração realizada com sucesso!',
            'success',
            3000
          );
          this.router.navigate(['/faturamento-contratos']);
        }
      });
  }

  integrateSapInvoicing(): void {
    this._lotDetailService
      .integrateLotInvoiceWithSap(this.lote.BatchId.toString())
      .pipe(
        switchMap((response) =>
          this._lotDetailService.validationLotWithSap(
            this.lote.BatchId.toString()
          )
        )
      )
      .subscribe({
        next: (response) => {
          this.snackbarService.openSnackBar(
            'Integração realizada com sucesso!',
            'success',
            3000
          );
          this.router.navigate(['/faturamento-contratos']);
        }
      });
  }

  integrateSapTransfer(): void {
    this._lotDetailService
      .integrateLotTransferWithSap(this.lote.BatchId.toString())
      .subscribe({
        next: (response) => {
          this.snackbarService.openSnackBar(
            'Integração realizada com sucesso!',
            'success',
            3000
          );
          this.router.navigate(['/repasse-comissao']);
        }
      });
  }

  //handleCancelSapEvent(): void {
  //  switch (this.batchType) {
  //    case 'invoice':
  //      this.cancelSapBatchInvoice();
  //      break;

  //    case 'transfer':
  //      this.cancelSapBatchTransfer();
  //      break;
  //  }
  //}

  //cancelSapBatchInvoice(): void {
  //  this._lotDetailService
  //    .cancelBatchInvoiceWithSap(this.lote.BatchId.toString())
  //    .subscribe({
  //      next: (response) => {
  //        this.snackbarService.openSnackBar(
  //          'NF cancelada com sucesso!',
  //          'success',
  //          3000
  //        );
  //        this.router.navigate(['/faturamento-contratos']);
  //      }
  //    });
  //}

  cancelSapBatchTransfer(): void {
    this._lotDetailService
      .cancelBatchTransferWithSap(this.lote.BatchId.toString())
      .subscribe({
        next: (response) => {
          this.snackbarService.openSnackBar(
            'NF cancelada com sucesso!',
            'success',
            3000
          );
          this.router.navigate(['/repasse-comissao']);
        }
      });
  }

  getBatchEventLogs(): void {
    const observers = forkJoin([
      this._apiBatchService.getInvoiceBatchEventLog(
        this.lote.BatchNumber,
        this.lote.BatchId
      ),
      this._apiBatchService.getInvoiceBatchEventSapLog(this.lote.BatchId)
    ]);

    observers.subscribe({
      next: ([logs, logsSap]) => {
        this._dialogService
          .openBatchEventLogDialog(logs.Data, logsSap.Data)
          .then((response) => {});
      }
    });
  }

  getRouteParent(): string {
    this.urlLote = this._route.snapshot.parent?.url[0].path as string;
    return this.urlLote;
  }

  onSelectFile(eventFile: { event: Event; fileName: string }): void {
    const target = eventFile.event.target as HTMLInputElement;

    const { file, fileName } = this._apiBatchService.validateFile(target);

    if (!!file) {
      const batchId = `${this.lote.BatchId}`;

      const data: IInvoiceInfo = {
        BatchId: this.lote.BatchId.toString(),
        InvoiceDate: '',
        InvoiceNumber: ''
      };

      const dialogRef = this._dialog.open(CampoNfComponent, {
        disableClose: true,
        data
      });

      dialogRef.afterClosed().subscribe((invoice: IInvoiceInfo | boolean) => {
        if (invoice) {
          this._apiBatchService
            .postInvoiceFile(batchId, file)
            .pipe(
              switchMap((response) =>
                this._apiBatchService.postInvoiceInfo(invoice as IInvoiceInfo)
              )
            )
            .subscribe({
              next: (response) => {
                this.file = file;
                this.annexList[0].File = file;
                this.updateValuesInvoice(invoice as IInvoiceInfo);
                this._apiBatchService.updateTemplateValuesEvent.next(
                  invoice as IInvoiceInfo
                );
                this.checkIntegrationSap();
                this.snackbarService.openSnackBar(
                  'Arquivo enviado com sucesso!',
                  'success',
                  3000
                );
              }
            });
        }
      });
    }

    target!.value = '';
  }

  updateValuesInvoice(invoice: IInvoiceInfo): void {
    this.lote.StatusOfOnlending = 'Aprovado';
    this.lote.InvoiceDate = invoice.InvoiceDate;
    this.lote.InvoiceNumber = invoice.InvoiceNumber;
  }

  showAnnexes(): boolean {
    const routeActive: string = this.getRouteParent();

    if (
      (routeActive === 'faturamento-contratos' &&
        this.lote?.InvoiceNumber &&
        !this.lote?.CancelInvoiceNumber) ||
      routeActive === 'repasse-comissao'
    ) {
      return true;
    }

    return false;
  }

  checkIfBatchIsCancelable(): void {
    if (
      this.batchType === 'invoice' &&
      this.lote.BatchStatus?.toLowerCase().trim() === 'faturado' &&
      !this.lote.PaymentDate
    ) {
      console.log('Lote cancelável');
      this.allowCancelAllContractsBatch = true;
    }
  }

  handleCancelAllContractsBatchEvent(event: boolean): void {
    this._apiBatchService.cancelAllContractsBatch(this.id, event).subscribe({
      next: (response) => {
        this.snackbarService.openSnackBar(
          response.Message ?? 'Lote processado com sucesso!',
          'success',
          3000
        );
        this.router.navigate(['/faturamento-contratos']);
      },
      error: (error) => {
        console.error('Erro ao cancelar lote:', error);
        this.snackbarService.openSnackBar(
          error.Message ?? 'Erro ao cancelar lote',
          'danger',
          3000
        );
      }
    });
  }
}
